import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useState } from 'react';
import { SideNavButton } from '../SideNavButton';
import { ProfileMenu } from './ProfileMenu';

export const ProfileButton = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  // When the ProfileButton is clicked, set the anchor element
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Close the ProfileMenu by clearing the anchor
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <SideNavButton
        dataTestId="profile-button"
        onClick={handleClick}
        tooltip="Profile"
        icon={fas.faUser}
      />
      <ProfileMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      />
    </>
  );
};
